var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 33H3.133A2.133 2.133 0 011 30.867V3.133C1 1.955 1.955 1 3.133 1H18.25c.565 0 1.107.225 1.507.624l8.351 8.352c.4.4.625.942.625 1.507v.184",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.066 1v8.533c0 1.178.956 2.134 2.134 2.134h8.533M11.551 13.598L8.52 17.64a1.067 1.067 0 01-1.607.114L5.267 16.11M11.551 23.198L8.52 27.24a1.067 1.067 0 01-1.607.114l-1.645-1.646M15.933 18.067h5.333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M32.12 21.08L21.265 31.933 15.933 33 17 27.667l10.852-10.853a3.008 3.008 0 014.254 0l.013.012a3.008 3.008 0 010 4.254z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgStockInventory;